<script>
import { Head, Link } from "@inertiajs/inertia-vue3";
import Layout from "@/Pages/Shared/Layout.vue";

export default {
    components: {
        Link,
        Head
    },
    data() {
        return {};
    },
    methods: {
        toogleBlock(block) {
            block.showBlock = !block.showBlock;
        }
    },
    layout: Layout
};
</script>

<template>
    <Head title="Cayma, Fesih ve İade Koşulları" />

    <main class="my-6 max-w-kbmobile md:max-w-tablet ts:max-w-ts 2xl:max-w-7xl mt-12 mx-auto">
        <!--        <section class="flex justify-center items-center flex-col w-full mb-12">-->
        <!--            <div class="flex justify-center items-center mb-10">-->
        <!--                <div class="flex justify-center items-center bg-kbgreen rounded-full w-28 h-28">-->
        <!--                    <svg xmlns="http://www.w3.org/2000/svg" width="43.015" height="78.955" viewBox="0 0 43.015 78.955">-->
        <!--                        <g id="Group_4141" data-name="Group 4141" transform="translate(0 0)">-->
        <!--                            <path-->
        <!--                                id="Path_3349"-->
        <!--                                data-name="Path 3349"-->
        <!--                                d="M473.847,415.2H472.2a5.587,5.587,0,0,1-5.581-5.581v-1.387a17.076,17.076,0,0,1,1.934-8.548,44.963,44.963,0,0,1,5.417-7.278,32.075,32.075,0,0,0,3.683-4.439,7.467,7.467,0,0,0,1.163-4.13c0-3.445-2.245-5.121-6.863-5.121a27.868,27.868,0,0,0-7.564,1.135,6.368,6.368,0,0,1-8.116-6.123v-2.807a6.246,6.246,0,0,1,3.685-5.725,36.563,36.563,0,0,1,27-.235,21.4,21.4,0,0,1,9.074,6.877,16.563,16.563,0,0,1,3.255,10.039,16.327,16.327,0,0,1-3.147,10.04,57.393,57.393,0,0,1-8.8,8.966,62.707,62.707,0,0,0-5.642,5.315,9.811,9.811,0,0,0-2.346,4.367,5.566,5.566,0,0,1-5.5,4.636Z"-->
        <!--                                transform="translate(-456.268 -362.491)"-->
        <!--                                fill="#fff"-->
        <!--                            />-->
        <!--                            <path id="Path_3350" data-name="Path 3350"-->
        <!--                                  d="M480.951,518.1h-.218a10.344,10.344,0,0,1,0-20.688h.218a10.344,10.344,0,0,1,0,20.688Z"-->
        <!--                                  transform="translate(-464.291 -439.141)" fill="#fff" />-->
        <!--                        </g>-->
        <!--                    </svg>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--            <button class="bg-black text-white rounded-full py-2 px-4 self-center text-2xl">Sıkça Sorulan Sorular-->
        <!--            </button>-->
        <!--        </section>-->
        <section class="mt-6 flex flex-col items-center justify-center mb-20">
            <div class="text-2xl font-semibold text-center mb-7 text-minigreen">Cayma, Fesih ve İade Koşulları</div>
            <div class="flex justify-between w-full lg:w-full py-4 rounded-xl mb-4">
                <div class="font-santralregular">
                    <p class="text-sm text-justify">
                        Bu metin, ticari veya mesleki olmayan amaçlarla hareket eden gerçek kişiler için hazırlanmış
                        olup bu içerisinde ürün kiralayan kişiler “Kullanıcı” olarak anılacaktır. Bu metinin amacı,
                        Kullanıcıları cayma hakkı, fesih, kira süresinin sona ermesi ile ürün / ürünlerin iadesi
                        süreçleri ile ilgili bilgilendirmektir.
                        <br>
                        <br>
                        <a href="https://kiralamini.com">www.kiralamini.com </a> internet sitesi üzerinden elektronik
                        ortamda sipariş verdiğiniz takdirde, size sunulan Ön Bilgilendirme Formu’nu ve Mesafeli Kira
                        Sözleşme’ni (“Sözleşme”) kabul etmiş sayılırsınız. Cayma, Fesih ve İade Koşulları metni,
                        Bilgilendirme Formu ve Sözleşme’nin yerine geçmez.
                        <br>
                        <br>
                        <span class="font-bold text-base">Cayma</span>
                        <br>
                        <br>
                        Kullanıcı, cayma hakkı bulunan hallerde, ürün / ürünlerin teslim alındığı gün başlayacak şekilde
                        on dört (14) gün içinde herhangi bir gerekçe göstermeksizin ve cezai şart ödemeksizin
                        sözleşmeden cayma hakkına sahiptir. Cayma hakkı süresinin belirlenmesinde;
                        <br>
                    </p>
                    <ul class="ml-6 list-outside text-sm mt-5 space-y-4 font-santralregular">
                        <li class="font-santralregular"> Tek sipariş konusu olup ayrı ayrı teslim edilen mallarda, Kullanıcı veya Kullanıcı
                            tarafından belirlenen üçüncü kişinin son malı teslim aldığı gün,
                        </li>
                        <li class="font-santralregular">Birden fazla parçadan oluşan mallarda, Kullanıcı veya Kullanıcı tarafından belirlenen üçüncü
                            kişinin son parçayı teslim aldığı gün
                        </li>
                        <li class="font-santralregular">Belirli bir süre boyunca malın düzenli tesliminin yapıldığı sözleşmelerde, tüketicinin veya
                            tüketici tarafından belirlenen üçüncü kişinin ilk malı teslim aldığı gün esas alınır.
                        </li>
                    </ul>
                    <div class="text-sm mt-5">Kullanıcı aşağıdaki sözleşmelerde cayma hakkını kullanamaz:</div>

                    <ul class="ml-6 list-outside text-sm mt-5 space-y-4 font-santralregular">
                        <li class="font-santralregular">Fiyatı finansal piyasalardaki dalgalanmalara bağlı olarak değişen ve satıcı veya
                            sağlayıcının kontrolünde olmayan mal veya hizmetlere ilişkin sözleşmeler.
                        </li>
                        <li class="font-santralregular">Tüketicinin istekleri veya kişisel ihtiyaçları doğrultusunda hazırlanan mallara ilişkin
                            sözleşmeler.
                        </li>
                        <li class="font-santralregular">Çabuk bozulabilen veya son kullanma tarihi geçebilecek malların teslimine ilişkin
                            sözleşmeler.
                        </li>
                        <li class="font-santralregular">Tesliminden sonra ambalaj, bant, mühür, paket gibi koruyucu unsurları açılmış olan
                            mallardan; iadesi sağlık ve hijyen açısından uygun olmayanların teslimine ilişkin
                            sözleşmeler.
                        </li>
                        <li class="font-santralregular">Tesliminden sonra başka ürünlerle karışan ve doğası gereği ayrıştırılması mümkün olmayan
                            mallara ilişkin sözleşmeler.
                        </li>
                        <li class="font-santralregular">Malın tesliminden sonra ambalaj, bant, mühür, paket gibi koruyucu unsurları açılmış olması
                            halinde maddi ortamda sunulan kitap, dijital içerik ve bilgisayar sarf malzemelerine ilişkin
                            sözleşmeler.
                        </li>
                        <li class="font-santralregular">Abonelik sözleşmesi kapsamında sağlananlar dışında, gazete ve dergi gibi süreli yayınların
                            teslimine ilişkin sözleşmeler.
                        </li>
                        <li class="font-santralregular">Belirli bir tarihte veya dönemde yapılması gereken, konaklama, eşya taşıma, araba kiralama,
                            yiyecek-içecek tedariki ve eğlence veya dinlenme amacıyla yapılan boş zamanın
                            değerlendirilmesine ilişkin sözleşmeler.
                        </li>
                        <li class="font-santralregular">Elektronik ortamda anında ifa edilen hizmetler veya tüketiciye anında teslim edilen
                            gayrimaddi mallara ilişkin sözleşmeler.
                        </li>
                        <li class="font-santralregular">Cayma hakkı süresi sona ermeden önce, tüketicinin onayı ile ifasına başlanan hizmetlere
                            ilişkin sözleşmeler.
                        </li>
                    </ul>
                    <p class="text-sm text-justify">
                        <br>
                        Cayma hakkı, Kullanıcı’nın tek taraflı bildirimi ile gerçekleşir. Cayma hakkının belirtilen süre
                        içerisinde Kiralamini’ye yöneltilmiş olması gerekir. Cayma hakkı bildirimi, (bu linkte bulunan)
                        cayma formu doldurulup imzalandıktan sonra <a href="mailto:destek@kiralamini.com">destek@kiralamini.com </a>
                        adresine e-posta atılarak yapılır.
                        <br>
                        <br>
                        Kullanıcı’nın, cayma süresi içerisinde ürün / ürünlerde meydana gelen değişiklik, hasar ve
                        bozulmalar dâhil tüm zararlardan sorumludur.
                        <br><br>
                        Kullanıcı’nın, ürün / ürünleri teslim aldıktan sonra cayma iradesini ortaya koyması durumunda,
                        Kullanıcıya ürün / ürünlerin teslim tarihi ile Kiralamini’ye iade tarihi arasında geçen süre,
                        Sözleşme’de belirlenen aylık kira tutarı doğrultusunda ücretlendirilir.
                        <br><br>
                        <span class="font-bold text-base">Sözleşme’nin Kiralamini Tarafından Feshedilmesi</span>
                        <br><br>
                        Kiralamini, Sözleşmeyi:
                        <br>
                    </p>
                    <ul class="ml-6 list-outside text-sm mt-5 space-y-4 font-santralregular">
                        <li class="font-santralregular">Kullanıcı tarafından ürün / ürünlerin belirlene kargo şubesi tarafından süresinde teslim
                            alınmaması;
                        </li>
                        <li class="font-santralregular">Kullanıcı’nın, Üyelik Sözleşmesi veya Sözleşme hükümlerine aykırı davranışları;</li>
                        <li class="font-santralregular">Ürün / ürünlerin kullanım amacına uygun, titiz bir şekilde, işleyişine, teknik özelliklerine
                            ve kullanım talimatlarına uygun bir olarak kullanılmaması;
                        </li>
                        <li class="font-santralregular">Ürün / ürünlere kasıtlı olarak zarar vermesi;</li>
                        <li class="font-santralregular">Ürün / ürünlerin Kullanıcı’nın şüpheli konumda olduğu bir soruşturma veya sanık olduğu bir
                            kovuşturma kapsamında suç işlenmesi için ve bir suçun gerçekleştirilmesi için kullanıldığına
                            yönelik iddia olması;
                        </li>
                        <li class="font-santralregular">Vadesi gelen aylık kira bedelinin, vadeyi takip eden on (10) gün içerisinde tahsil
                            edilememesi,
                        </li>
                        <li class="font-santralregular">Kullanıcı tarafından Kiralanan ürün / ürünlerin tedarik edilememesi;</li>
                        <li class="font-santralregular">nedeniyle derhal etkili olmak üzere herhangi bir bildirim süresi tanımaksızın
                            feshedebilir.
                        </li>
                    </ul>
                    <p class="text-sm text-justify">
                        <br>
                        <span class="font bold text-base">Ürün / Ürünlerin İadesi</span>
                        <br>
                        <br>
                        Kullanıcı:
                        <br>
                    </p>
                    <ul class="ml-6 list-outside text-sm mt-5 space-y-4 font-santralregular">
                        <li class="font-santralregular">Sözleşme’inden caydığını bildirdiği,</li>
                        <li class="font-santralregular">Sözleşme’nin süresinin sona erdiği,</li>
                        <li class="font-santralregular">Sözleşme’nin Kullanıcı veya Kiralamini tarafından feshedildiği, veya</li>
                        <li class="font-santralregular">Sözleşme’nin başka bir nedenle sona ermesi,</li>
                    </ul>
                    <p class="text-sm text-justify">
                        durumlarında Kullanıcı, ürün / ürünlerin kutusu, ambalajı, varsa aksesuarları ile birlikte
                        eksiksiz ve hasarsız olarak teslim etmek ile yükümlüdür. Eksik gönderilen kutu, ambalaj ve
                        aksesuarlar, iade tarihindeki perakende piyasa fiyatları üzerinden ücretlendirilecek ve
                        Kullanıcı’dan tahsil edilecektir.
                        <br><br>
                        Kullanıcı, kiraladığı ürün / ürünlerin aynısını teslim etmek zorundadır. Kiralanan ürün /
                        ürünlerin Uluslararası Mobil Cihaz Kimliği (IMEI) numarası ve seri numaraları ile ürün /
                        ürünlerin tespitine yarayan diğer işaret ve kayıt numaraları kontrol edilecektir. IMEI veya seri
                        numaraları kasten silinmiş ürünlerin iadesi kabul edilmeyecek olup bunlar Sözleşme’de yer alan
                        zayi koşullarına göre işleme alınacaktır.
                        <br><br>
                        <span class="font bold text-base">İade Öncesi İşlemler</span>
                        <br><br>
                        Ürün / ürünler iade edilmeden önce şifrelemeler kaldırılmalı ve fabrika ayarlarına geri
                        getirilmelidir.
                        <br><br>
                        Ürün / ürünler hafızasında yer alan bilgi, belge, resim, dosya ve türevleri dahil türlü veri
                        Kullanıcı tarafından iade edilmeden önce silinmelidir. Kiralamini, ürün / ürünlerde yer alan
                        verilerin muhafazasından sorumlu değildir.
                        <br><br>
                        <span class="font bold text-base">Ürün İade Süresi</span>
                        <br><br>
                        <b>Kullanıcı:</b>
                        <br>
                    </p>
                    <ul class="ml-6 list-outside text-sm mt-5 space-y-4 font-santralregular">
                        <li class="font-santralregular">cayma hakkını kullandığına ilişkin bildirimi yönelttiği</li>
                        <li class="font-santralregular">Sözleşme’nin Kullanıcı veya Kiralamini tarafından feshedildiği, veya</li>
                        <li class="font-santralregular">Sözleşme’nin başka bir nedenle sona ermesi,</li>
                    </ul>
                    <p class="text-sm text-justify">
                        <br>
                        durumlarında Kiralamini tarafından iadeye ilişkin yazılı bilgilendirme tarihinden itibaren iki
                        (2) gün içerisinde cayma, fesih veya sona ermeye konu ürün / ürünleri Kiralamini’ye geri
                        göndermek zorundadır. Bilgilendirmeler, e-posta üzerinden yapılacaktır.
                        <br><br>
                        Kullanıcı, Sözleşme’nin süresi bitmeden iki (2) gün önce ürün / ürünleri Kiralamini’ye geri
                        göndermek zorundadır.
                        <br><br>
                        Kullanıcı’nın, ürün / ürünleri teslim aldıktan sonra cayma iradesini ortaya koyması durumunda,
                        Kullanıcıya ürün / ürünlerin teslim tarihi ile Kiralamini’ye iade tarihi arasında geçen süre,
                        Sözleşme’de belirlenen aylık kira tutarı doğrultusunda ücretlendirilir.
                        <br><br>
                        <span class="font bold text-base">İade Yöntemi</span>
                        <br><br>
                        Ürün / ürünler, Kiralamini tarafından belirtilen kargo şirketi vasıtasıyla Kiralamini tarafından
                        verilen posta adresine karşı ödemeli olarak gönderilecektir.
                        <br><br>
                        <span class="font bold text-base">Hasarlar</span>
                        <br><br>
                        Sözleşme hükümlerine uygun olağan kullanım dışında meydana gelen hasarlar ve eksilmeler
                        Sözleşme’nde yer alan tamirat hükümlerine göre işleme alınacaktır.
                    </p>
                </div>
            </div>

        </section>
    </main>
</template>
